
var OutcomeSetManager = function(orgID,bCanManage){
    var oThis = this;
    oThis.orgID = orgID;
    oThis.bCanManage = bCanManage || false;
    // oThis.apiRoot = "/org/" + orgID + "/outcomeset/";
    oThis.apiRoot = buildRoute(mantlroutes.org_outcomeset_list, { orgid: orgID });
    oThis.viewRoot = buildView(mantlroutes.org_outcomes, { orgid: orgID });
    oThis.Actions = Reflux.createActions(['fetchSets','createSet','updateSet','deleteSet']);
    oThis.containerID;
    oThis.modalsID = "outcomesetModal";
    oThis.msgStack = new MessageStack();
    oThis.createStore();

    oThis.handleStack = function(){
        oThis.msgStack.Display(); //should we put these in a program builder container?
        oThis.msgStack.Clear();
    }

    //Program Designer
    oThis.OutcomeSetManager = createReactClass({
        mixins: [Reflux.connect(oThis.OutcomeSetStore, 'sets')],

        componentDidUpdate: function(){
            var $manager = $(ReactDOM.findDOMNode(this));
            //$manager.find('.collapsible').collapsible();
        },

        render: function() {
            if(this.state.sets){

                var sets = [];
                for(var i = 0; i < this.state.sets.length; i++){
                    var oSet = this.state.sets[i];
                    sets.push(<oThis.OutcomeSetManagerItem set={oSet} key={oSet.id} edit={oThis.bCanManage} />);
                }
                if(sets.length > 0){
                    return (
                        <div>
                            {(function(){
                                if (oThis.bCanManage) {
                                  return (<oThis.OutcomeSetManagerNew />);
                                }
                            })()}

                            <h2 className="h3">Outcome Sets</h2>
                            <ul className="collection" data-collapsible="expandable">
                                {sets}
                            </ul>
                        </div>
                    );
                } else {
                    return (
                        <div>
                            {(function(){
                                if (oThis.bCanManage) {
                                  return (<oThis.OutcomeSetManagerNew />);
                                }
                            })()}
                            <h2 className="h3">Outcome Sets</h2>
                            <div className="alert alert--information">Your organization hasn't created any outcomes yet.</div>
                        </div>
                    );
                }

            } else {
                return (
                    <div>
                        <h2 className="h3">Outcome Sets</h2>
                        <div className="program"><div className="spinner spinner--pulsing"><div className="spinner-ring"></div></div></div>
                    </div>
                );
            }

        }
    });

    //New Set
    //Set Actions
    oThis.OutcomeSetManagerNew = createReactClass({
        componentDidMount: function() {
            var $badge = $(ReactDOM.findDOMNode(this));
            var oComponent = this;
        },

        handleNew: function() {
            ReactDOM.render(<oThis.OutcomesSetManagerNewModal />, document.getElementById(oThis.modalsID));
        },

        componentDidUpdate: function() {
        },

        render: function() {
            return (
                <button className="float--right button--success button--sm" id="newSet" onClick={this.handleNew}>New Outcome Set</button>
            );

        }
    });


    //Set
    oThis.OutcomeSetManagerItem = createReactClass({
        componentDidMount: function() {
            var $badge = $(ReactDOM.findDOMNode(this));
            var oComponent = this;
        },

        componentDidUpdate: function() {
        },

        render: function() {
            var oComponent = this;
            var description = "No description";
            if(this.props.set.description != null && this.props.set.description.length > 0) {
                description = this.props.set.description
            }
            return (
                <li className="collection-item">
                    {this.props.set.url && (<div><a href={this.props.set.url} className="text--primary text--small" target="_blank" title="External Reference URL">{this.props.set.url}</a></div>)}
                    {this.props.set.code && (<code className="float--right text--small text--tightbottom" title="Framework Keycode">{this.props.set.code}</code>)}
                    <h3 className="h5"><Icon classes="icon-map-o" /> <a className="text--secondary" href={oThis.viewRoot + this.props.set.id}>{this.props.set.title}</a></h3>
                    <blockquote>{description}</blockquote>
                    <oThis.OutcomeSetManagerItemActions set={this.props.set} edit={this.props.edit} />
                </li>
            );

        }
    });

    //Set Actions
    oThis.OutcomeSetManagerItemActions = createReactClass({
        componentDidMount: function() {
            var $badge = $(ReactDOM.findDOMNode(this));
            var oComponent = this;
        },

        handleModify: function() {
            ReactDOM.render(<oThis.OutcomesSetManagerRenameModal set={this.props.set} />, document.getElementById(oThis.modalsID));
        },

        handleDelete: function() {
            var oComponent = this;
            alertify.okBtn("Delete Entire Set").okStyle("border--danger").confirm("<h1 class='h4'>Are you sure you want to delete <br /><i>" + htmlEncode(this.props.set.title) + "</i>?</h1><p class='text--danger'>This can't be undone.</p>")
            .then(function (resolvedValue) {
                // "resolvedValue" is an object with the following keys: buttonClicked and event
                resolvedValue.event.preventDefault();
                if(resolvedValue.buttonClicked == "ok"){
                    //Double-check
                    alertify.okBtn("Yes, I'm Sure").confirm("<h1 class='h4 text--danger'>Are you really sure?</h1><p>Any badges linked to these outcomes will lose their alignment links.</p>")
                    .then(function (resolvedValue) {
                        resolvedValue.event.preventDefault();
                        if(resolvedValue.buttonClicked == "ok"){
                            oThis.Actions.deleteSet(oComponent.props.set.id);
                        }
                    })
                }

            });
        },

        componentDidUpdate: function() {
        },

        render: function() {
            var oComponent = this;
            if(this.props.edit){
                return (
                    <div className="text--left">
                        <a className="button button--skinny button--flat" href={oThis.viewRoot + this.props.set.id}>Open</a> <button className="button--skinny button--flat" id={"rename_" + this.props.set.id} onClick={oComponent.handleModify}>Modify</button> <button className="button--skinny button--flat text--danger" onClick={oComponent.handleDelete}>Delete</button>
                    </div>
                );
            } else {
                return (<div></div>);
            }

        }
    });

    //Rename Modal
    oThis.OutcomesSetManagerRenameModal = createReactClass({

        handleSave: function() {
            var oSet = {
                id: this.props.set.id,
                title: $("#outcomesetRename").find("input[name=title]").val(),
                code: $("#outcomesetRename").find("input[name=code]").val(),
                url: $("#outcomesetRename").find("input[name=url]").val(),
                description: $("#outcomesetRename").find("textarea[name=description]").val()
            }
            if(oSet.title.length > 0){
                oThis.Actions.updateSet(oSet);
            } else {
                alertify.warning("Title can't be left blank.")
            }
        },

        componentDidMount: function() {
            var $modal = $(ReactDOM.findDOMNode(this));
            var modalNode = ReactDOM.findDOMNode(this).parentNode;
            $modal.on("modal:close",function(){
                $modal.off("modal:close").closeModal();
                ReactDOM.unmountComponentAtNode(modalNode);
            });
            $modal.attr({
                "aria-labelledby": "rename_" + this.props.set.id,
                "role": "dialog",
                "tabindex" : "-1"
            }).openModal();
        },

        componentWillUnmount: function() {
            //console.log("component unmounted");
        },

        render: function() {
            var oComponent = this;
            return (
                <div id="outcomesetRename" className="modal">
                    <div className="modal-container">
                        <div className="modal-header">
                            Modify Outcome Set
                            <a href="#close" className="modal-close">&times;</a>
                        </div>

                        <div className="modal-body">
                            <p><label className="required" htmlFor={"title_" + this.props.set.id}>Set Title</label>
                            <input type="text" id={"title_" + this.props.set.id} name="title" defaultValue={this.props.set.title} aria-required='true'/></p>

                            <p><label htmlFor={"code_" + this.props.set.id}>Framework Keycode</label>
                            <input type="text" id={"code_" + this.props.set.id} name="code" defaultValue={this.props.set.code} /></p>

                            <p><label htmlFor={"url_" + this.props.set.id}>External Reference URL</label>
                            <input type="text" id={"url_" + this.props.set.id} name="url" placeholder="http://standards.server.com/framework/123" defaultValue={this.props.set.url} /></p>

                            <p><label htmlFor={"description_" + this.props.set.id}>Description</label>
                            <textarea rows="4" id={"description_" + this.props.set.id} name="description">{this.props.set.description}</textarea></p>
                        </div>

                        <div className="modal-footer">
                            <p><button className="button--success" onClick={this.handleSave}>Save Changes</button></p>
                        </div>
                    </div>
                </div>
            );
        }
    });

    //Add Set Modal
    oThis.OutcomesSetManagerNewModal = createReactClass({

        handleSave: function() {
            var oSet = {
                title: $("#outcomesetNew").find("input[name=title]").val(),
                description: $("#outcomesetNew").find("textarea[name=description]").val(),
                code: $("#outcomesetNew").find("input[name=code]").val(),
                url: $("#outcomesetNew").find("input[name=url]").val(),
                external: false
            }
            if(oSet.title.length > 0){
                oThis.Actions.createSet(oSet);
            } else {
                alertify.warning("Title can't be left blank.")
            }
        },

        componentDidMount: function() {
            var $modal = $(ReactDOM.findDOMNode(this));
            var modalNode = ReactDOM.findDOMNode(this).parentNode;
            $modal.on("modal:close",function(){
                $modal.off("modal:close").closeModal();
                ReactDOM.unmountComponentAtNode(modalNode);
            });
            $modal.attr({
                "aria-labelledby": "newSet",
                "role": "dialog",
                "tabindex" : "-1"
            }).openModal();
        },

        componentWillUnmount: function() {
            //console.log("component unmounted");
        },

        render: function() {
            var oComponent = this;
            return (
                <div id="outcomesetNew" className="modal">
                    <div className="modal-container">
                        <div className="modal-header">
                            Add New Outcome Set
                            <a href="#close" className="modal-close">&times;</a>
                        </div>

                        <div className="modal-body">
                            <p><label htmlFor="newTitle" className="required">Set Title</label>
                            <input type="text" id="newTitle" name="title" aria-required='true' /></p>

                            <p><label htmlFor="newCode">Framework Keycode</label>
                            <input type="text" id="newCode" name="code" /></p>

                            <p><label htmlFor="newURL">External Reference URL</label>
                            <input type="text" id="newURL" name="url" placeholder="http://standards.server.com/framework/123" /></p>


                            <p><label htmlFor="newDescription">Description</label>
                            <textarea rows="4" id="newDescription" name="description"></textarea></p>
                        </div>

                        <div className="modal-footer">
                            <p><button className="button--success" onClick={this.handleSave}>Save New Set</button></p>
                        </div>
                    </div>
                </div>
            );
        }
    });



};

OutcomeSetManager.prototype.renderList = function(containerID) {
    this.containerID = containerID;
    ReactDOM.render(<this.OutcomeSetManager />, document.getElementById(this.containerID));
}

//REFLUX STORE
//Note to self, the actions handling and routing patterns here are terrible
//Very obviously the first ones built. Destroy all of this with fire later.
OutcomeSetManager.prototype.createStore = function() {
    var oThis = this;

    oThis.OutcomeSetStore = Reflux.createStore({
        listenables: oThis.Actions,
        sets: {}, //outcome sets

        init: function() {
        },

        getInitialState: function() {
            this.onFetchSets();
        },

        onFetchSets: function() {
            var oStore = this;
            httpGet(oThis.apiRoot).then(
                function(value) {
                    //console.table(JSON.parse(value));
                    oStore.sets = JSON.parse(value);
                    oStore.trigger(oStore.sets);
                })
            .catch(
                function(reason) {
                    console.error('Error loading outcome sets.', reason);
                    alertify.error('Unable to load outcome sets.')
                });
        },

        onCreateSet: function(oSet) {
            var data = oSet;
            if(oSet != null && oSet.title != undefined){
                httpPost(oThis.apiRoot, data).then(
                    function(value){
                        oThis.Actions.fetchSets(); //need to refetch since alpha order probably changed.
                        oThis.msgStack.AddSuccess("Outcome Set Created");
                        oThis.handleStack();
                        $("#outcomesetNew").closeModal();
                    })
                .catch(
                    function(reason) {
                        oThis.msgStack.AddError("Unable to create new outcome set. " + reason);
                        oThis.handleStack();
                    });
            }
        },

        onUpdateSet: function(oSet) {
            var data = oSet;
            if(oSet != null && oSet.id != undefined){
                httpPatch(oThis.apiRoot + "/" + oSet.id, data).then(
                    function(value){
                        oThis.Actions.fetchSets(); //easiest to just redraw, set sizes will be small
                        oThis.msgStack.AddSuccess("Outcome Set Updated");
                        oThis.handleStack();
                        $("#outcomesetRename").closeModal();
                    })
                .catch(
                    function(reason) {
                        oThis.msgStack.AddError("Unable to update outcome set. " + reason);
                        oThis.handleStack();
                    });
            }
        },

        onDeleteSet: function(setID) {
            ///DELETE /org/orgpk/outcomeset/setpk
            httpDelete(oThis.apiRoot + "/" + setID).then(
                function(value){
                    oThis.Actions.fetchSets(); //easiest to just redraw, set sizes will be small
                    oThis.msgStack.AddSuccess("Outcome Set Removed");
                    oThis.handleStack();
                })
            .catch(
                // Log the rejection reason
                function(reason) {
                    console.error('Error deleting set.', reason);
                    oThis.msgStack.AddError("Unable to delete Outcome Set.");
                    oThis.handleStack();
                });
        }


    });
}
